var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { capitalize } from "../../utils/capitalize";
var styles = function (theme) {
    var _a, _b;
    return ({
        root: {
            width: '100%',
            display: 'block',
            boxSizing: 'border-box',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: theme.spacing(0, 3),
        },
        maxWidthMd: (_a = {},
            _a[theme.breakpoints.up('md')] = {
                maxWidth: theme.breakpoints.values.md,
            },
            _a),
        maxWidthLg: (_b = {},
            _b[theme.breakpoints.up('lg')] = {
                maxWidth: theme.breakpoints.values.lg,
            },
            _b),
        fluid: {
            maxWidth: '100%',
        },
        noGutters: {
            padding: theme.spacing(0),
        },
    });
};
var useStyles = makeStyles(styles, { name: 'SnContainer' });
export var Container = function (props) {
    var _a;
    var className = props.className, _b = props.maxWidth, maxWidth = _b === void 0 ? 'lg' : _b, fluid = props.fluid, noGutters = props.noGutters, others = __rest(props, ["className", "maxWidth", "fluid", "noGutters"]);
    var classes = useStyles(props);
    return (React.createElement("div", __assign({ className: classNames(classes.root, [classes["maxWidth" + capitalize(maxWidth)]], (_a = {},
            _a[classes.fluid] = fluid,
            _a[classes.noGutters] = noGutters,
            _a), className) }, others)));
};
